<template>
  <v-row justify="center">
    <v-col align-self="center" class="d-flex justify-center">
      <v-card class="text-left" width="600">
        <v-toolbar :dark="$vuetify.theme.dark" color="primary">
          <v-toolbar-title>
            {{ $t("Служба поддержки") }}
          </v-toolbar-title>
        </v-toolbar>
        <static-page :page-tag="pageTag" />
        <v-row>
          <v-col>
            <div style="position: relative; overflow: hidden">
              <iframe
                  :src="`https://yandex.ru/map-widget/v1/-/${segmentConfig.locationCode}?lang=${locale}`"
                  width="600"
                  height="400"
                  frameborder="1"
                  allowfullscreen="true"
                  style="position: relative" />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.frame {
  border: 0px currentColor;
  border-image: none;
}
</style>

<script>
  import StaticPage from '@/components/reused/staticPages/StaticPage.vue'
  import { STATIC_PAGES_TAGS } from '@/constants/business'

  export default {
    components: {
      StaticPage
    },
    computed: {
      pageTag () {
        return STATIC_PAGES_TAGS.STATIC_SUPPORT
      },
      locale () {
        if (this.controlLocale === 'ru-ru') {
          return 'ru_RU'
        } else {
          return 'en_US'
        }
      }
    }
  }
</script>
